<style src="./Notice.scss" lang="scss"></style>

<template lang="pug">
  .notice(
    :class="classList"
  )
    .notice__icon
      Icon(
        name="warn"
      )
    .notice__body
      h3.notice__title(
        v-if="title"
      ) {{ title }}
      p.notice__text(
        v-html='text'
      )
</template>

<script>
import Icon from "@/components/Icon/Icon";

export default {
  props: {
    title: String,
    text: String,
    type: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Icon
  },
  computed: {
    classList() {
      return this.type.map(type => `is-${type}`);
    }
  }
};
</script>
